<template>
  <div>
    <label class="story-city-input-label d-flex align-center">
      <v-icon color="primary" class="mr-2">$title</v-icon>
      <div>{{ $t("story.title") }}</div>
    </label>
    <v-text-field
      v-model="name"
      class="story-city-text-input mb-0"
      :label="$t('story.basicInfoForm.addYourTitle')"
      :rules="[
        () =>
          name == null ||
          name.length <= TITLE_TEXT_MAX_LENGTH ||
          $t('forms.maxLimitCharacters', { limit: TITLE_TEXT_MAX_LENGTH }),
      ]"
      hide-details="auto"
      outlined
      solo
      flat
      :disabled="disabled"
    />
  </div>
</template>

<script>
const TITLE_TEXT_MAX_LENGTH = 40;
export default {
  props: {
    value: String,
    disabled: Boolean,
  },
  data() {
    return {
      name: this.value,
    };
  },
  watch: {
    value(newValue) {
      if (this.name != newValue) {
        this.name = newValue;
      }
    },
    name(newValue) {
      this.$emit("input", newValue);
    },
  },
  computed: {
    TITLE_TEXT_MAX_LENGTH() {
      return TITLE_TEXT_MAX_LENGTH;
    },
  },
};
</script>
